import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import WhatsAppButton from "../../components/feature/WhatsAppButton";
import ServicesDetail from "./components/ServicesDetail";

const WA_LINK = "https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada";

export default function Services() {
  const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://example.com";
  const pageUrl = `${siteUrl}/servicios`;

  const schemaService = {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    "name": "Servicios de Colposcopia y Ginecología en Panamá | Dr. Erick Tejada",
    "description": "Colposcopia, Papanicolaou, detección de VPH y consulta ginecológica en Ciudad de Panamá. Especialista Dr. Erick Tejada.",
    "url": pageUrl,
    "inLanguage": "es",
    "about": {
      "@type": "MedicalCondition",
      "name": "VPH - Virus del Papiloma Humano",
      "code": {
        "@type": "MedicalCode",
        "code": "B97.7",
        "codingSystem": "ICD-10"
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Inicio", "item": siteUrl },
        { "@type": "ListItem", "position": 2, "name": "Servicios", "item": pageUrl }
      ]
    },
    "provider": {
      "@type": "Physician",
      "name": "Dr. Erick Tejada",
      "telephone": "+507-6613-2697",
      "medicalSpecialty": "Gynecology"
    }
  };

  const schemaFAQ = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "¿Qué es la colposcopia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "La colposcopia es un procedimiento diagnóstico que permite examinar con detalle el cuello uterino para detectar lesiones precancerosas o signos de VPH utilizando un colposcopio de aumento."
        }
      },
      {
        "@type": "Question",
        "name": "¿Cuándo se recomienda realizarse una colposcopia?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Se recomienda cuando el Papanicolaou muestra resultados anormales, cuando hay sospecha de infección por VPH o cuando el médico detecta cambios en el cuello uterino durante el examen."
        }
      },
      {
        "@type": "Question",
        "name": "¿Qué forma de pago aceptan?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Solo aceptamos pago en efectivo. No se aceptan tarjetas de crédito ni débito."
        }
      }
    ]
  };

  return (
    <>
      <title>Servicios de Colposcopia y Ginecología en Panamá | Dr. Erick Tejada</title>
      <meta name="description" content="Colposcopia, Papanicolaou, detección de VPH y consulta ginecológica en Ciudad de Panamá. El Dr. Erick Tejada ofrece atención especializada en salud femenina con enfoque preventivo. Agenda tu cita: +507 6613-2697." />
      <meta name="keywords" content="colposcopia Panamá, Papanicolaou Ciudad de Panamá, detección VPH Panamá, ginecología preventiva, Dr. Erick Tejada servicios" />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Servicios de Colposcopia y Ginecología en Panamá | Dr. Erick Tejada" />
      <meta property="og:description" content="Colposcopia, Papanicolaou, detección de VPH y ginecología preventiva en Ciudad de Panamá. Atención especializada con el Dr. Erick Tejada." />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content="https://static.readdy.ai/image/0538348e5f7265469219be823f4b4c0f/b33c731a0a8a80a76070c43759aaf839.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Servicios de Colposcopia y Ginecología | Dr. Erick Tejada Panamá" />
      <meta name="twitter:description" content="Colposcopia, VPH y ginecología preventiva en Ciudad de Panamá." />
      <script type="application/ld+json">{JSON.stringify(schemaService)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaFAQ)}</script>
      <main>
        <Navbar />

        {/* Hero */}
        <section className="relative pt-24 md:pt-28 pb-12 md:pb-20 overflow-hidden bg-gradient-to-br from-teal-900 via-teal-800 to-slate-800">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://public.readdy.ai/ai/img_res/8c13363e6ffd586214cef6904988e08a.jpg"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
            <span
              className="inline-flex items-center gap-2 text-teal-300 text-xs md:text-sm font-medium mb-5 flex-wrap justify-center"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-stethoscope-line"></i>
              Especialización en Colposcopia y Ginecología · Panamá
            </span>
            <h1
              className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 md:mb-5"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Servicios Especializados en{" "}
              <span className="italic font-normal" style={{ fontFamily: "'Lora', serif" }}>
                Salud Femenina
              </span>
            </h1>
            <p
              className="text-white/75 text-sm md:text-lg max-w-xl mx-auto mb-6 md:mb-8"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Ofrecemos atención ginecológica integral con enfoque en detección temprana del VPH, colposcopia y prevención del cáncer cervicouterino en Ciudad de Panamá.
            </p>
            <a
              href={WA_LINK}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-7 py-3.5 md:py-4 rounded-full transition-all text-sm md:text-base whitespace-nowrap cursor-pointer w-full sm:w-auto"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
              Agendar Cita por WhatsApp
            </a>
          </div>
        </section>

        {/* Services Detail */}
        <ServicesDetail />

        <Footer />
        <WhatsAppButton />
      </main>
    </>
  );
}
